// ─────────────────────────────────────────────────────────────────────────────
// DOC-LIFECYCLE-001 (Phase D+E) — Blob-URL-Registry: Vorschauen werden als BLOB mit
// Authorization-Header geladen (KEIN ?token= mehr) → lokale blob:-URL. Diese Registry
// garantiert: beim Schließen wird JEDE erzeugte URL wieder freigegeben (revokeAll),
// und ein erneutes register auf demselben Schlüssel leckt nie die alte URL.
// create/revoke sind injizierbar → testbar ohne Browser (blob-registry.test.mjs).
// ─────────────────────────────────────────────────────────────────────────────

export function createBlobRegistry(urlApi) {
  const create = urlApi?.create || ((blob) => URL.createObjectURL(blob));
  const revoke = urlApi?.revoke || ((u) => URL.revokeObjectURL(u));
  const urls = new Map();   // key → blob:-URL

  return {
    // Blob registrieren → blob:-URL; alte URL desselben Schlüssels wird SOFORT freigegeben.
    register(key, blob) {
      const old = urls.get(key);
      if (old) { try { revoke(old); } catch (_) { /* Aufräumen darf nie werfen */ } }
      const url = create(blob);
      urls.set(key, url);
      return url;
    },
    get(key) { return urls.get(key) || null; },
    // ALLE URLs freigeben (Drawer/Seite schließt). Idempotent — doppelt schließen ist ok.
    revokeAll() {
      for (const url of urls.values()) { try { revoke(url); } catch (_) { /* s. o. */ } }
      urls.clear();
    },
  };
}
